<script lang="ts" setup>
import { PhClipboardText } from '@phosphor-icons/vue';
import { useI18n } from 'vue-i18n';

const { t } = useI18n();
const textWidths = ['72%', '55%', '68%'];
const SKELETON_ROWS = textWidths.map((_, i) => i);
</script>

<template>
  <div class="card">
    <div class="card-header">
      <p class="card-header-title">
        <PhClipboardText :size="18" class="mr-2" />
        {{ t('overview.afterMarketTable.title') }}
      </p>
    </div>

    <div class="card-content p-0">
      <table class="table is-fullwidth is-striped mb-0">
        <thead>
          <tr>
            <th>{{ t('overview.afterMarketTable.table.visit') }}</th>
            <th class="date-cell">
              {{ t('overview.afterMarketTable.table.date') }}
            </th>
          </tr>
        </thead>
        <tbody>
          <tr
            v-for="i in SKELETON_ROWS"
            :key="i"
            class="skeleton-row"
            aria-hidden="true"
          >
            <td class="col-text">
              <div class="skeleton-cell" :style="{ width: textWidths[i] }" />
            </td>
            <td class="date-cell">
              <div class="skeleton-cell date-skeleton" />
            </td>
          </tr>
        </tbody>
      </table>
    </div>
  </div>
</template>
<style scoped>
.card {
  overflow: hidden;
}

.table th,
.table td {
  padding: 0.6rem 0.85rem;
  vertical-align: middle;
}

.table tbody tr {
  height: 2.7rem;
}

.col-text {
  width: 65%;
}

.date-cell {
  width: 35%;
  text-align: right !important;
}

.skeleton-row td {
  border-color: transparent !important;
}

.skeleton-cell {
  height: 1em;
  border-radius: 4px;
  background: linear-gradient(90deg, #ebebeb 25%, #f5f5f5 50%, #ebebeb 75%);
  background-size: 200% 100%;
  animation: skeleton-shimmer 1.4s ease-in-out infinite;
}

.date-skeleton {
  width: 6rem;
  margin-left: auto;
}

@keyframes skeleton-shimmer {
  0% {
    background-position: 200% 0;
  }
  100% {
    background-position: -200% 0;
  }
}
</style>
